<script setup lang="ts">
import {Badge} from "@/core/components/ui/badge";
import {Beaker, ClipboardList, LayoutGrid, Send} from "@lucide/vue";
import {computed} from "vue";

/**
 * Where a message (or a whole batch) comes from.
 * Shared by the batch templates (`targetable_type`) and the conversation messages (`sourceable.type`).
 */
export type MessageSourceType = 'program' | 'laboratory' | 'survey' | null;

const props = defineProps<{
    type: MessageSourceType;
    name?: string | null;
}>();

const config = computed(() => {
    if (props.type === 'laboratory') {
        return {label: 'Espace marque', icon: Beaker, class: 'border-violet-200 bg-violet-50 text-violet-700'};
    }

    if (props.type === 'program') {
        return {label: 'Module', icon: LayoutGrid, class: 'border-blue-200 bg-blue-50 text-blue-700'};
    }

    if (props.type === 'survey') {
        return {label: 'Questionnaire', icon: ClipboardList, class: 'border-amber-200 bg-amber-50 text-amber-700'};
    }

    return {label: 'Manuel', icon: Send, class: 'border-slate-200 bg-slate-50 text-slate-600'};
});

const label = computed(() => {
    if (props.name) {
        return `${config.value.label} - ${props.name}`;
    }

    return config.value.label;
});
</script>

<template>
  <Badge variant="outline" :class="['gap-1 py-0.5 max-w-full min-w-0', config.class]" :title="label">
    <component :is="config.icon" class="w-3.5 h-3.5 shrink-0" />
    <span class="line-clamp-1 flex-1 min-w-0 break-all">{{ label }}</span>
  </Badge>
</template>
